export const nonDateStatusList = ["status-7", "status-8", "verified_completed"]

export const statusList = [
    {
      text: "In Progress",
      value: "status-7",
    },
    {
      text: "Done",
      value: "status-8",
    },
    {
      text: "Verified Completed",
      value: "verified_completed",
    },
]